<template lang="pug">
  .b2b-filter-button-auditorias
    //- pre {{ filter }}
    ods-tag(
      closable='',
      type='secondary',
      @close='closeTagFilter')
        span.b2b-filter-button__value {{ $t(filter.value) }} :
        span.b2b-filter-button__query {{ filter.labelText }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'

export default {
  name: 'b2b-filter-button-auditorias',

  props: {
    filter: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      filterListAfterRemove: []
    }
  },

  computed: {
    ...mapGetters([
      'queryAudits',
      'listSelectedFiltersAudits'
    ])
  },

  methods: {
    ...mapActions([
      'getAudits',
      'queryAuditsState'
    ]),
    comprobarSeleccion () {
      if ((this.queryAudits.dateTimeFrom === undefined || this.queryAudits.dateTimeFrom === '') &&
        (this.queryAudits.dateTimeTo === undefined || this.queryAudits.dateTimeTo === '') &&
        (this.queryAudits.idSender === undefined || this.queryAudits.idSender === '') &&
        (this.queryAudits.idReceiver === undefined || this.queryAudits.idReceiver === '') &&
        (this.queryAudits.filename === undefined || this.queryAudits.filename === '') &&
        (this.queryAudits.documentNumber === undefined || this.queryAudits.documentNumber === '') &&
        (this.queryAudits.idDocumentType === undefined || this.queryAudits.idDocumentType === '') &&
        (this.queryAudits.idStatus === undefined || this.queryAudits.idStatus === '') &&
        (this.queryAudits.batch === undefined || this.queryAudits.batch === '') &&
        (this.queryAudits.idProject === undefined || this.queryAudits.idProject === '') &&
        (this.queryAudits.idCommunicationsProtocol === undefined || this.queryAudits.idCommunicationsProtocol === '') &&
        (this.queryAudits.idAuditDocumentModule === undefined || this.queryAudits.idAuditDocumentModule === '') &&
        (this.queryAudits.idDocumentFormatInput === undefined || this.queryAudits.idDocumentFormatInput === '') &&
        (this.queryAudits.idDocumentFormatOutput === undefined || this.queryAudits.idDocumentFormatOutput === '') &&
        (this.queryAudits.batchName === undefined || this.queryAudits.batchName === '') &&
        (this.queryAudits.hidden === undefined || this.queryAudits.hidden === '') &&
        (this.queryAudits.childCountFrom === undefined || this.queryAudits.childCountFrom === '') &&
        (this.queryAudits.childCountTo === undefined || this.queryAudits.childCountTo === '') &&
        (this.queryAudits.processingTimeFrom === undefined || this.queryAudits.processingTimeFrom === '') &&
        (this.queryAudits.processingTimeTo === undefined || this.queryAudits.processingTimeTo === '')) {
        this.$notify({
          title: this.$t('msg_generics.filter_no_selected'),
          type: 'info',
          position: 'top-right',
          customClass: 'b2b-notification-info',
          duration: 10000
        })
        return false
      } else {
        return true
      }
    },
    async closeTagFilter () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete')
      })
      this.filter.selected = false // eslint-disable-line
      this.filterListAfterRemove = this.listSelectedFiltersAudits.filter(item => item.prop !== this.filter.prop)

      switch (this.filter.prop) {
        case 'idSender':
          this.queryAudits.idSender = ''
          break
        case 'idReceiver':
          this.queryAudits.idReceiver = ''
          break
        case 'filename':
          this.queryAudits.filename = ''
          break
        case 'documentNumber':
          this.queryAudits.documentNumber = ''
          break
        case 'idDocumentType':
          this.queryAudits.idDocumentType = ''
          break
        case 'dateTimeFrom':
          this.queryAudits.dateTimeFrom = ''
          break
        case 'dateTimeTo':
          this.queryAudits.dateTimeTo = ''
          break
        case 'batch':
          this.queryAudits.batch = ''
          break
        case 'idStatus':
          this.queryAudits.idStatus = ''
          break
        case 'idProject':
          this.queryAudits.idProject = ''
          break
        case 'idCommunicationsProtocol':
          this.queryAudits.idCommunicationsProtocol = ''
          break
        case 'idAuditDocumentModule':
          this.queryAudits.idAuditDocumentModule = ''
          break
        case 'idDocumentFormatInput':
          this.queryAudits.idDocumentFormatInput = ''
          break
        case 'idDocumentFormatOutput':
          this.queryAudits.idDocumentFormatOutput = ''
          break
        case 'hidden':
          this.queryAudits.hidden = ''
          break
        case 'childCountFrom':
          this.queryAudits.childCountFrom = ''
          break
        case 'childCountTo':
          this.queryAudits.childCountTo = ''
          break
        case 'processingTimeFrom':
          this.queryAudits.processingTimeFrom = ''
          break
        case 'processingTimeTo':
          this.queryAudits.processingTimeTo = ''
          break
        default:
          break
      }

      try {
        if (this.comprobarSeleccion()) {
          await this.queryAuditsState(this.queryAudits)
          dataQuery.query = this.queryAudits
          await this.getAudits(dataQuery)

          this.$emit('closeTag', { filter: this.filter, listAfterRemove: this.filterListAfterRemove })
        }
      } catch (error) {
        console.log('closeTagFilter CATCH: ', error)
        let errorSms = ''
        let statusCode = null

        statusCode = error.status
        switch (statusCode) {
          case 400:
            errorSms = this.$i18n.messages.es.error.e400
            break
          case 401:
            errorSms = this.$i18n.messages.es.error.e401
            router.push({ name: 'login' })
            break
          case 500:
            errorSms = this.$i18n.messages.es.error.e500
            break
          default:
            errorSms = this.$i18n.messages.es.error.default
            break
        }
        this.$notify({
          title: errorSms,
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
      } finally {
        load.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
